export const COMMENTS = 'Comments' as const;
export const WORKLOG = 'Worklog' as const;

export const PermalinkType = {
	COMMENTS: 'focusedCommentId',
	WORKLOG: 'focusedWorklogId',
} as const;
